import { render, staticRenderFns } from "./NossaRealeza.vue?vue&type=template&id=7e8cc0b6&"
import script from "./NossaRealeza.vue?vue&type=script&defer=true&lang=js&"
export * from "./NossaRealeza.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports